import {
  AddonList,
  ChartFilter,
  Checkins,
  CompareToggle,
  Daypass,
  DetailHeader,
  MembershipStatsCards,
  StatsBanner,
  StatsLineChart,
  statsViewModel,
  useDateRange,
  useFetcher,
  useSelectedCustomer,
} from '@entrecode/statsapp-components';

import snippets from '@i18n/lang';
import { useRef, useState } from 'react';
import { useParams } from 'react-router';
import { ClubResponse } from 'src/*';
import useSWR from 'swr';

const activationsTooltip = `
  ${snippets.customerDetail.staticCards.tooltips.activations}
  <br /><br />
  ${snippets.customerDetail.staticCards.tooltips.storno}
`;
const cancellationsTooltip = `
  ${snippets.customerDetail.staticCards.tooltips.cancelations}
  <br /><br />
  ${snippets.customerDetail.staticCards.tooltips.terminations}
`;

const ClubDetail = () => {
  const { clubId } = useParams();
  const { start, end, interval } = useDateRange();
  const fetcher = useFetcher();
  const selectedCustomer = useSelectedCustomer();
  const shareable = useRef(null);

  const [showPrev, setShowPrev] = useState(false);
  const [prevAddonsCount, setPrevAddonsCount] = useState(5);

  const v2Params = new URLSearchParams({
    dataManagerID: selectedCustomer?.dataManagerID,
    studioNumber: clubId,
    start,
    end,
    compare: interval === 'week' ? '52weeks' : 'year',
    seoTitle: selectedCustomer?.seoTitle,
  }).toString();

  const { data: v2, isLoading } = useSWR(
    selectedCustomer && (start || end) ? `/statsapp/club?${v2Params}` : null,
    fetcher<ClubResponse>,
    {
      onSuccess: (data) => {
        if (data?.addons?.length > 0) {
          setPrevAddonsCount(data.addons.length);
        }
      },
    },
  );

  const vm = statsViewModel(v2, {
    start,
    end,
    interval,
    compareWithPrevious: showPrev,
  });

  return (
    <div className="">
      <DetailHeader>{v2?.name}</DetailHeader>
      <div className="px-4">
        <div>
          <ChartFilter shareable={shareable} headline={`Club: ${v2?.name}`} />

          <CompareToggle
            compareWithPrevios={showPrev}
            setCompareWithPrevious={setShowPrev}
            visibleRange={vm.visibleRange}
          />

          {!isLoading && vm.banner === 'stale' && (
            <StatsBanner kind="stale" staleUntil={vm.staleUntil} />
          )}

          <div ref={shareable}>
            {!isLoading && vm.banner === 'empty' ? (
              <StatsBanner kind="empty" />
            ) : (
              <>
                <StatsLineChart data={vm.chartData} />

                <div className="mt-6">
                  <MembershipStatsCards
                    core={v2}
                    title={v2?.name}
                    activationsTooltip={activationsTooltip}
                    cancellationsTooltip={cancellationsTooltip}
                  />
                </div>
              </>
            )}
          </div>
        </div>
        <div className="my-8">
          <AddonList prevAddonsCount={prevAddonsCount} addons={v2?.addons} club={v2} />
        </div>
        <Daypass club={v2} />
        <Checkins club={v2} />
      </div>
    </div>
  );
};

export default ClubDetail;
